module.exports = __webpack_public_path__ + "static/media/2-how-to.de25bd6f.png";